export function getProjectShortTitle(title: string | null) {
  if (!title) {
    return null
  }
  if (title.length <= 10) {
    return title
  }

  const capitalLetters = title
    .split("")
    .filter(char => /^[A-Z]+$/.test(char))
    .slice(0, 4)
    .join("")

  if (capitalLetters.length >= 3) {
    return capitalLetters
  }
  const wordStarts = title
    .split(" ")
    .map(word => word.slice(0, 2))
    .join("")

  if (wordStarts.length >= 3) {
    return wordStarts.slice(0, 4)
  }

  return title.slice(0, 4)
}
